import { formatNumber, getEventLabel } from "../helpers";

export function EventBreakdownItem({ eventName, total, maximum }) {
  const width = maximum ? Math.max(3, (Number(total) / maximum) * 100) : 0;

  return (
    <div className="space-y-1">
      <div className="flex justify-between gap-3 text-sm text-gray-700">
        <span>{getEventLabel(eventName)}</span>
        <strong>{formatNumber(total)} </strong>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-gray-100">
        <div className="h-full rounded-full bg-scale-500" style={{ width: `${width}%` }} />
      </div>
    </div>
  );
}
